import { StorageKey } from '../../interfaces/storage-key';
import useSettingsStorageService from '../../../../auth/hooks/useSettingsStorageService';
import useTeamSettings from '../../../team/hooks/useTeamSettingsService';

export function useDraftPipelineStorage() {
  const { isDraftPipelineEnabled } = useTeamSettings();
  const { getSettings, applySettings } = useSettingsStorageService();

  const getDraftSourceDataFromStorage = () => {
    if (!isDraftPipelineEnabled) {
      return null;
    }

    return getSettings(StorageKey.CREATE_DRAFT_PIPELINE_SOURCE);
  };

  const getDraftSourceId = () => {
    return getDraftSourceDataFromStorage()?.id;
  };

  const setDraftSourceDataInStorage = (value) => {
    applySettings(StorageKey.CREATE_DRAFT_PIPELINE_SOURCE, value);
  };

  const clearDraftSourceDataFromStorage = () => {
    applySettings(StorageKey.CREATE_DRAFT_PIPELINE_SOURCE, null);
  };

  const clearDraftDestinationDataFromStorage = () => {
    applySettings(StorageKey.CREATE_DRAFT_PIPELINE_DESTINATION, null);
  };

  const getDraftDestinationDataFromStorage = () => {
    if (!isDraftPipelineEnabled) {
      return null;
    }
    return getSettings(StorageKey.CREATE_DRAFT_PIPELINE_DESTINATION);
  };

  const setDraftDestinationDataInStorage = (value) => {
    if (!isDraftPipelineEnabled) {
      return null;
    }

    applySettings(StorageKey.CREATE_DRAFT_PIPELINE_DESTINATION, value);
  };

  const clearDraftStorage = () => {
    clearDraftSourceDataFromStorage();
    clearDraftDestinationDataFromStorage();
  };

  return {
    getDraftSourceId,
    getDraftDestinationDataFromStorage,
    setDraftDestinationDataInStorage,
    clearDraftDestinationDataFromStorage,
    getDraftSourceDataFromStorage,
    setDraftSourceDataInStorage,
    clearDraftSourceDataFromStorage,
    clearDraftStorage
  };
}
